import { TravelerInformation} from '.';
import { InputField, Address } from '../../shared/models';

export interface PrimaryTraveler {
    info: TravelerInformation;
    address: Address;
    emailAddress: InputField<string>;
    phoneNumber: InputField<string>;
}